import { useEffect, useState } from 'react'

import { faCode, faCodeBranch, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Loader from 'react-loaders'

import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

// Projects data from resume
const projects = [
  {
    id: 1,
    title: 'RWA Ecosystem Architecture (Almabrook)',
    description: 'Designed end-to-end architecture for a Real-World Asset ecosystem including MPC custody, regulated exchange, and secondary marketplace with Shariah-compliant and AAOIFI-aligned design.',
    technologies: ['Solidity', 'MPC', 'RWA', 'AAOIFI', 'Compliance', 'KYC/AML'],
    category: 'Blockchain Architecture',
    status: 'Completed',
    year: '2025',
    company: 'Almabrook',
    features: [
      'MPC-based key management and custody',
      'Regulated exchange and secondary marketplace',
      'Shariah-compliant architecture',
      'KYC/AML and asset tokenization integrations',
      'Audit-grade traceability'
    ],
    images: [],
    githubUrl: null,
    liveUrl: null,
    isPrivate: true
  },
  {
    id: 2,
    title: 'Stiqy Pricing Model',
    description: 'Led the team in developing a pricing model enabling communities to pay via stablecoin or fiat. Supports all EVM chains for USDC/USDT and Stripe for fiat payments.',
    technologies: ['Solidity', 'EVM', 'Stripe', 'Stablecoins', 'Node.js'],
    category: 'Blockchain Development',
    status: 'Completed',
    year: '2024',
    company: 'Stiqy',
    features: [
      'Multi-chain stablecoin support (USDC, USDT)',
      'Fiat payments via Stripe',
      'Community-focused pricing',
      'EVM chain compatibility'
    ],
    images: [],
    githubUrl: null,
    liveUrl: null,
    isPrivate: true
  },
  {
    id: 3,
    title: 'Stiqy Web3 Marketing Platform',
    description: 'Web3-based marketing tool for communities in the Blockchain Gaming space. Supports 90+ blockchain networks using Moralis and The Graph.',
    technologies: ['Node.js', 'MySQL', 'Next.js', 'Solidity', 'Moralis', 'The Graph'],
    category: 'Full Stack Development',
    status: 'Completed',
    year: '2024',
    company: 'Stiqy',
    features: [
      '90+ blockchain network support',
      'Moralis and The Graph integration',
      'Community marketing tools',
      'Blockchain gaming focus'
    ],
    images: [],
    githubUrl: null,
    liveUrl: null,
    isPrivate: true
  },
  {
    id: 4,
    title: 'Bumpies Weekly Lottery',
    description: 'Deployed a smart contract for a game where users earn tickets to enter a weekly lottery. Built with Solidity and React.js on Base Mainnet.',
    technologies: ['Solidity', 'React.js', 'Base Mainnet', 'Web3'],
    category: 'Smart Contracts',
    status: 'Completed',
    year: '2024',
    company: 'Bumpies',
    features: [
      'Ticket-earning game mechanic',
      'Weekly lottery system',
      'Base Mainnet deployment',
      'React.js frontend'
    ],
    images: [],
    githubUrl: null,
    liveUrl: null,
    isPrivate: true
  },
  {
    id: 5,
    title: 'Bumpies Brawl Quest (BBQ) Web3 Game',
    description: 'Led Web3 team in developing a complete on-chain game similar to FrenPet with complex Diamond contracts. Diamond contracts in Solidity, frontend in React.js on Base Mainnet.',
    technologies: ['Solidity', 'Diamond Pattern', 'React.js', 'Base Mainnet', 'Web3 Gaming'],
    category: 'Web3 Gaming',
    status: 'Completed',
    year: '2024',
    company: 'Bumpies',
    features: [
      'Complex Diamond smart contract architecture',
      'Full on-chain game logic',
      'Base Mainnet deployment',
      'FrenPet-style mechanics'
    ],
    images: [],
    githubUrl: null,
    liveUrl: null,
    isPrivate: true
  },
  {
    id: 6,
    title: 'OnChain Identity/Progress Verification Soulbound NFTs (Avocad-0)',
    description: 'Developed and minted Soulbound NFTs for users who participated in events. NFTs are locked to a specific wallet and cannot be transferred or sold.',
    technologies: ['Solidity', 'Node.js', 'MySQL', 'Soulbound NFTs', 'Binance Mainnet'],
    category: 'NFT Development',
    status: 'Completed',
    year: '2023',
    company: 'Telos Labs / Avocado',
    features: [
      'Non-transferable Soulbound NFTs',
      'Event participation verification',
      'Wallet-locked identity',
      'Binance Mainnet'
    ],
    images: [],
    githubUrl: null,
    liveUrl: null,
    isPrivate: true
  },
  {
    id: 7,
    title: 'Content Platform for Web3 Communities (Avocado DAO)',
    description: 'Content-based platform showcasing blockchain game information with forums, on-chain game data, and user blockchain profiles.',
    technologies: ['Node.js', 'MySQL', 'React', 'Solidity', 'Binance', 'Ethereum', 'Polygon', 'Cronos', 'Avalanche'],
    category: 'Full Stack Development',
    status: 'Completed',
    year: '2023',
    company: 'Telos Labs / Avocado',
    features: [
      'Forums and community features',
      'On-chain game information',
      'User blockchain profiles',
      'Multi-chain integration'
    ],
    images: [],
    githubUrl: null,
    liveUrl: null,
    isPrivate: true
  },
  {
    id: 8,
    title: 'Avocado Staking Pools',
    description: 'Developed staking pools for ERC20 token staking and vesting. Admin panel to create pools with configurable limits, duration, and vesting periods.',
    technologies: ['Solidity', 'Node.js', 'MySQL', 'React', 'ERC20', 'Binance'],
    category: 'DeFi',
    status: 'Completed',
    year: '2023',
    company: 'Telos Labs / Avocado',
    features: [
      'Customizable staking pools',
      'Vesting period configuration',
      'Admin panel management',
      'Binance Mainnet'
    ],
    images: [],
    githubUrl: null,
    liveUrl: null,
    isPrivate: true
  },
  {
    id: 9,
    title: 'Participation & Ranked SoulBound NFTs (Avocacy Badges)',
    description: 'Minted Soulbound NFTs for event participation and rankings. NFTs locked to user wallets and non-transferable.',
    technologies: ['Solidity', 'Node.js', 'MySQL', 'Soulbound NFTs', 'Polygon'],
    category: 'NFT Development',
    status: 'Completed',
    year: '2023',
    company: 'Telos Labs / Avocado',
    features: [
      'Event participation tracking',
      'Ranked achievement system',
      'Polygon Mainnet',
      'Non-transferable badges'
    ],
    images: [],
    githubUrl: null,
    liveUrl: null,
    isPrivate: true
  },
  {
    id: 10,
    title: 'Ethereum PoS Validators',
    description: 'Configured, deployed, and maintained 20 Ethereum validators for block signing and yield. Approximately 640 ETH staked across validators. Deployed on Azure.',
    technologies: ['Ethereum PoS', 'Azure', 'DevOps', 'Staking'],
    category: 'Infrastructure',
    status: 'Completed',
    year: '2023',
    company: 'Telos Labs',
    features: [
      '20 validators deployed',
      '~640 ETH staked',
      'Azure infrastructure',
      'Block signing and yield'
    ],
    images: [],
    githubUrl: null,
    liveUrl: null,
    isPrivate: true
  },
  {
    id: 11,
    title: 'Asset Backed Token Marketplace (Dinisium)',
    description: 'Developed white-label marketplace for asset-backed crypto tokens. Portals for Super Admin, Admin, and Investors. Daily transactions mapped on Ethereum mainnet.',
    technologies: ['Node.js', 'MySQL', 'React', 'Solidity', 'Ethereum Mainnet', 'Ubuntu'],
    category: 'Blockchain Development',
    status: 'Completed',
    year: '2022',
    company: 'Dinisium',
    features: [
      'White-label marketplace',
      'Role-based portals (Super Admin, Admin, Investors)',
      'Ethereum mainnet integration',
      'Daily transaction mapping'
    ],
    images: [],
    githubUrl: null,
    liveUrl: null,
    isPrivate: true
  }
]

const Projects = () => {
  const projectsArray = 'Projects'.split('')
  const [letterClass, setLetterClass] = useState('text-animate')
  const [filter, setFilter] = useState('All')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  const categories = ['All', ...new Set(projects.map(project => project.category))]

  const filteredProjects = filter === 'All'
    ? projects
    : projects.filter(project => project.category === filter)

  return (
    <>
      <div className="container projects-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={projectsArray}
              idx={15}
            />
          </h1>
          <p>
            A showcase of my technical projects spanning Web3, blockchain
            architecture, smart contracts, DeFi, NFTs, and full-stack development.
            Each project represents a solution to real-world challenges in the
            blockchain space.
          </p>

          <div className="filter-container">
            {categories.map(category => (
              <button
                key={category}
                className={`filter-btn ${filter === category ? 'active' : ''}`}
                onClick={() => setFilter(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        <div className="projects-container">
          <div className="projects-grid">
            {filteredProjects.map((project, index) => (
              <div key={project.id} className="project-card" style={{ animationDelay: `${index * 0.1}s` }}>
                {project.images && project.images.length > 0 && (
                  <div className="project-images">
                    <div className="image-carousel">
                      {project.images.map((image, idx) => (
                        <img key={idx} src={image} alt={`${project.title} ${idx + 1}`} />
                      ))}
                    </div>
                  </div>
                )}

                <div className="project-content">
                  <div className="project-header">
                    <div className="project-meta">
                      <span className="category">{project.category}</span>
                      <span className="year">{project.year}</span>
                      <span className={`status ${project.status.toLowerCase()}`}>
                        {project.status}
                      </span>
                    </div>
                    <h3 className="project-title">{project.title}</h3>
                    <p className="company">{project.company}</p>
                  </div>

                  <p className="project-description">{project.description}</p>

                  <div className="project-features">
                    <h4>Key Features:</h4>
                    <ul>
                      {project.features.map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="technologies">
                    {project.technologies.map((tech, idx) => (
                      <span key={idx} className="tech-tag">{tech}</span>
                    ))}
                  </div>

                  <div className="project-links">
                    {project.githubUrl && (
                      <a href={project.githubUrl} target="_blank" rel="noreferrer" className="project-link">
                        <FontAwesomeIcon icon={faCodeBranch} />
                        <span>Code</span>
                      </a>
                    )}
                    {project.liveUrl && (
                      <a href={project.liveUrl} target="_blank" rel="noreferrer" className="project-link">
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                        <span>Live Demo</span>
                      </a>
                    )}
                    {project.isPrivate && (
                      <span className="private-indicator">
                        <FontAwesomeIcon icon={faCode} />
                        <span>Private Project</span>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Projects
